<template>
    <router-link :to="link"  class="search-result">
        <div class="search-result__column" data-column="name" data-title="Name">
            <span class="user">
                <img
                    v-if="resource.avatar"
                    :src="resource.avatar.url"
                    class="avatar avatar--small"
                    :title="resource.unformatted_name"
                    :alt="`${resource.unformatted_name}'s avatar`"
                    width="32"
                    height="32"
                />
                <img
                    v-else
                    src="//placehold.it/32x32"
                    class="avatar avatar--small"
                    width="32"
                    height="32"
                    alt=""
                />
                <span v-html="resource.name" class="name"/>
            </span>
        </div>
        <div class="search-result__column" data-column="company" data-title="Company">
            <span v-text="resource.member"/>
        </div>
        <div class="search-result__column" data-column="location" data-title="Location">
            <span v-text="resource.location"/>
        </div>
        <div class="search-result__column" data-column="sector" data-title="Sector" v-if="resource.sectors && resource.sectors.length > 0">
            <span class="sector" v-for="sector in resource.sectors">{{ sector.name }}</span>
        </div>
    </router-link>
</template>
<script>
import { mapState } from 'vuex';

export default {
    name: 'UserSearchResult',
    props: {
        resource: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
        }),
        link() {
            return {
                name: 'view-user',
                params: { user_id: this.resource.id },
            };
        },
    },
}
</script>
<style lang="scss" scoped>
@import "~@/theme/_variables.scss";

.search-result {
    display: flex;
    flex-wrap: wrap;
    row-gap: 1rem;
    align-items: center;
    padding: 2rem;
    border: .1rem solid $border;
    border-radius: 1rem;

    .search-result__column {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: flex-start;
        gap: 1rem;

        span {
            color: black;
        }

        &:before {
            content: attr(data-title);
            color: $text;
            font-size: 1.4rem;
            font-weight: normal;
            line-height: 1;
            display: block;
        }

        &[data-column="name"] {
            flex: 1 1 auto;
            max-width: calc((100% - 20rem) - 20.2rem);
            font-weight: bold;
            padding-right: 1rem;

            a {
                color: black;
            }
        }

        &[data-column="company"] {
            flex: 0 0 20rem;

            span {
                line-height: 4rem;
                width: 19rem;
                display: inline;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        &[data-column="location"] {
            flex: 0 0 20rem;
            text-align: right;

            span {
                line-height: 4rem;
            }
        }

        &[data-column="sector"] {
            flex: 1 0 100%;
            width: 100%;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            gap: .5rem;
            margin-top: .5rem;

            &:before {
                flex: 1 0 100%;
                width: 100%;
            }

            .sector {
                margin-right: 0;
                margin-bottom: 0;
            }
        }
    }

    @media screen and (max-width: 991px) {
        row-gap: 2rem;
        align-items: flex-start;
        justify-content: space-between;

        .search-result__column {
            &[data-column="name"] {
                flex: 1 0 100%;
                max-width: 100%;
                padding-right: 0;

                a {
                    width: 100%;
                }
            }

            &[data-column="company"],
            &[data-column="location"] {
                flex: 0 0 calc(50% - .6rem);
                gap: 1rem;
            }
        }
    }
}
</style>
